export default __webpack_public_path__ + "static/media/P2000.44d2fdeb.jpg";